import styled from '@emotion/native';
import { Row } from 'components/base';
import { Logo, Profile, type ProfileProps } from 'design-system/navigation';
import { BASE_SIZE, PADDING } from 'design-system/theme';
import type React from 'react';

type TopBarProps = ProfileProps;

const Wrapper = styled(Row)(({ theme }) => ({
  flexDirection: 'row',
  backgroundColor: theme.color['base-grey'],
  justifyContent: 'space-between',
  paddingHorizontal: PADDING.s,
  height: BASE_SIZE[48],
  maxWidth: '100%',
}));

export const TopBar: React.FC<TopBarProps> = ({
  name,
  onProfilePress,
  onWardSelect,
  wards,
  ward,
}) => (
  <Wrapper unsetZIndex>
    <Logo />
    <Profile
      name={name}
      onProfilePress={onProfilePress}
      onWardSelect={onWardSelect}
      wards={wards}
      ward={ward}
    />
  </Wrapper>
);
